import React from "react";
import ItemComponent from "../../components/ItemComponent/ItemCopmonent";
import filter from "../../assets/images/filter.png"
import { sortByOrderAscending } from "../../helper/helper";
import { useHistory } from "react-router";
import { useSelector } from "react-redux";

const ProductsContent = ({ toggleDrawer, components, isLoading, count }) => {
    const history = useHistory()
    const selectedCategory = useSelector((state) => state.companyData.selectedCategory)
    const categoryProducts = useSelector((state) => state.companyData.categoryProducts)


    const getHeaderComponents = (component) => {
        switch (component.ID) {
            case "products-header":
                return <div className="header-text">{selectedCategory?.ProductCategory?.Category.toLowerCase()}
                </div>
            case "products-subheader":
                return <div className="subtext-content">
                    {component.Props.content}
                </div>
            default:
                return <div />
        }

    }
    const getProductsText = (productsComponent) => {
        return (
            <div className="header-content">
                {sortByOrderAscending(productsComponent).map((component, key) => {
                    return getHeaderComponents(component)

                })}
            </div>
        )
    }
    const getFilterContent = () => {
        return (
            <div className="product-content">
                <div className="filter-container" onClick={toggleDrawer}>
                    <img alt="" src={filter} />filter</div>
                <div className="product-count">{count} item(s)</div>
            </div>
        )
    }
    const getProdctsContent = (props) => {
        return (
            categoryProducts?.Result?.length > 0 ?
                <div className="products-list-container">
                    {categoryProducts?.Result?.map((product, key) => {
                        return <ItemComponent key={key} item={product} layout={props.layout}
                            onClick={() => {
                                history.push(`/product/${product.ID}`)
                            }} />
                    })}            </div>
                : <div className="empty-prod">No products found</div>
        )
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "products-header-content":
                return getProductsText(component.Components)
            case "product-filter-content":
                return isLoading ? "" : getFilterContent()
            case "product-content-section":
                return isLoading ? <div className="ecom-loader" /> : getProdctsContent(component.Props)
            default:
                return <div />
        }

    }
    return (
        <div className="EcommerceProduct-right">
            {sortByOrderAscending(components).map((component, key) => {
                return getComponents(component)

            })}

        </div>
    )
}
export default ProductsContent